module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.f72a493d.png";